import React, { useEffect, useMemo, useState, useCallback } from "react";
import axios from "axios";
import { GET_BACKLINK_REFRESH } from "../../utils/services";
import { ZustandStore } from "../../../store/zustand-store";
import CustomTable from "../../../Mycomponent/share/customTable";
import { Button } from "@mui/material";
import { post_backlink_data } from "../../../services/constants";
import AddProjectStore from "../../../store/AddProjectStore";

const BacklinkData = () => {
  const [backlinkData, setBacklinkData] = useState({
    data: [],
    loading: true,
    error: false,
  });
  const [loading, setLoading] = useState({});
  const [page, setPage] = React.useState(1);
  const { isAdminPerformAction } = ZustandStore((state) => state);
  const showNotification = AddProjectStore((state) => state.showNotification);

  const fetchSiteOverviewData = async () => {
    try {
      const response = await axios.get(GET_BACKLINK_REFRESH());
      setBacklinkData({
        data: response.data,
        loading: false,
        error: false,
      });
    } catch (error) {
      setBacklinkData({
        data: [],
        loading: false,
        error: true,
      });
      showNotification({
        message: "api call fail",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    fetchSiteOverviewData();
  }, []);

  const tableHeader = useMemo(() => {
    return [
      {
        label: "Domain",
        key: "domain",
        minWidth: 120,
        align: "left",
        width: "25%",
      },
      {
        label: "Include Subdomains",
        key: "include_subdomains",
        minWidth: 120,
        width: "25%",
        align: "center",
      },
      {
        label: "Last Updated",
        key: "last_update",
        minWidth: 120,
        align: "center",
        width: "25%",
      },
      {
        label: "",
        key: "space",
        minWidth: 120,
        align: "center",
        width: "25%",
        isAction: isAdminPerformAction?.isPerformAction,
      },
    ];
  }, [isAdminPerformAction?.isPerformAction]);

  const handleRefreshApi = useCallback(async (item) => {
    setLoading((prev) => ({ ...prev, [item.domain]: true }));
    try {
      const config = {
        domain: item.domain,
        include_subdomains: item.include_subdomains,
      };
      // Make API call
      await axios.post(post_backlink_data(config));
      showNotification({
        message: `Backlink data refresh for ${config.domain}`,
        severity: "success",
      });
    } catch (error) {
      showNotification({
        message: `API call failed to refresh data`,
        severity: "error",
      });
    } finally {
      setLoading((prev) => ({ ...prev, [item.domain]: false })); // Re-enable button
      fetchSiteOverviewData();
    }
  }, []);

  const tableData = useMemo(() => {
    return backlinkData?.data.map((item) => {
      return {
        domain: item?.domain,
        include_subdomains: item?.include_subdomains ? "TRUE" : "FALSE",
        last_update: (
          <span>{`${item.last_updated}/${item.month}/${item.year}`}</span>
        ),
        space: (
          <Button
            variant="contained"
            onClick={() => handleRefreshApi(item)}
            disabled={loading[item.domain]} // Disable while API call is in progress
          >
            {loading[item.domain] ? "Refreshing..." : "Refresh"}
          </Button>
        ),
      };
    });
  }, [backlinkData?.data, loading]);

  return (
    <>
      {backlinkData.error ? (
        <div>Error...</div>
      ) : (
        <CustomTable
          tableTitle="Backlinks"
          showSearchBar={true}
          rows={tableData}
          type="user_list"
          dataLoader={backlinkData.loading}
          tableHeader={tableHeader}
          page={page}
          setPage={setPage}
        />
      )}
    </>
  );
};

export default BacklinkData;
